import { render, staticRenderFns } from "./PersonaDocumentosView.vue?vue&type=template&id=5f1800cf&scoped=true"
import script from "./PersonaDocumentosView.vue?vue&type=script&lang=js"
export * from "./PersonaDocumentosView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1800cf",
  null
  
)

export default component.exports